import { IFormStyleConfig } from "@components/Form/interface/form.interfaces";
import { colors } from "@components/ui/colors";

/**
 * Custom styles for the FlowHub Hero Cards Form.
 * These styles are designed to be consistent with the rest of the application,
 * following the design patterns from Flow-DO and the global color palette.
 */
export const flowHubHeroCardsFormStyles: IFormStyleConfig = {
  // 1. Container & Wrappers
  container: {
    gap: "1.25rem",
    padding: "0.5rem 0",
  },
  fieldWrapper: {
    display: "flex",
    flexDirection: "column",
    gap: "0.5rem",
  },

  // 2. Text & Elements
  label: {
    fontWeight: 700,
    color: "var(--fx-surface-text, #0F172A)",
    fontSize: "0.875rem",
    marginBottom: "0.1rem",
  },
  helperText: {
    color: "var(--fx-surface-textsecondary, #64748B)",
    fontSize: "0.75rem",
    marginTop: "0.25rem",
  },
  errorText: {
    color: colors.danger[600],
    fontSize: "0.75rem",
    marginTop: "0.25rem",
  },
  submitButton: {
    backgroundColor: colors.orange.base,
    color: "#ffffff",
    padding: "0.8rem 1.5rem",
    borderRadius: "8px",
    border: "none",
    fontWeight: 700,
    cursor: "pointer",
    transition: "all 0.2s ease",
    width: "100%",
    marginTop: "1rem",
    fontSize: "0.9rem",
    letterSpacing: "0.025em",
  },

  // 3. Shared Input Styles
  sharedInputs: {
    backgroundColor: "var(--fx-surface-base, #FFFFFF)",
    width: "100%",
    borderRadius: "12px",
    padding: "16.5px 14px",
    border: `1px solid  ${colors.orange.base}`,
    outline: "none",
    boxSizing: "border-box",
    transition: "0.2s",
    color: "var(--fx-surface-text, #0F172A)",
  },

  // 4. Unique Input Styles
  text: { height: "48px" },
  textarea: { minHeight: "120px", resize: "vertical" as any },
  select: { cursor: "pointer", height: "48px" },
  address: { height: "48px" },

  // 5. Radio and Checkboxes
  radioContainer: {
    display: "flex",
    gap: "1.5rem",
    flexWrap: "wrap",
    padding: "0.5rem 0",
  },
  radioOption: {
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "0.6rem",
    fontSize: "0.875rem",
    color: "var(--fx-surface-textsecondary, #64748B)",
  },
  checkboxOption: {
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "0.6rem",
    fontSize: "0.875rem",
    color: "var(--fx-surface-textsecondary, #64748B)",
  },
};
